<template>
  <div class="premission_index">
    <button
        type="primary"
        class="add"
        icon="el-icon-plus"
        @click="addrecordclick"
        >新增</button
      >
    <el-row class="elAdd">
      <div class="elAddBox">
        <div class="box_regis">
          <span
            v-for="(item, index) in register"
            :key="index"
            @click="registerclick(item.name, item.id)"
            :class="
              item.name == regisactive ? 'registeractive register' : 'register'
            "
          >
            {{ item.name }}
          </span>
        </div>
        <div
          @click="dicomePop = true"
          style="
            color: #3EAF6A;
            font-size: 14px;
            cursor: pointer;
          "
        >
          上传影像
        </div>
      </div>
      <!-- <iframe class="prism-player" :src="'../../../static/pdf/web/viewer.html?file=' + 'http://hk.changhongit.com/pub/resource/application/2021060201744_c.pdf'" width="1000px" height="1000px"></iframe> -->
      <!-- <pdf src="./path/to/static/relativity.pdf"></pdf> -->
      <div class="search_div">
        <div>
          <el-input
            v-model="username"
            :class="[!activef?'search_input colorchange':'search_input searchchange']"

            size="medium "
            placeholder="病人姓名"
            ref="inputRef"
            @focus="f()"
            @blur="blurUsername()"
          >
          <i v-if="ffter == true" slot="prefix" class="el-input__icon el-icon-search"></i>
          <i v-if="ffter == false" slot="prefix" style="color:#009b43;" class="el-input__icon el-icon-search"></i>
          </el-input>
          <el-input
            v-model="studyNo"
            :class="[!activeff?'search_input colorchange':'search_input searchchange']"
            size="medium "
            placeholder="检查号"
            @focus="fr()"
            @blur="blurUsernamer()"
          >
          <i v-if="ffterr == true" slot="prefix" class="el-input__icon el-icon-search"></i>
          <i v-if="ffterr == false" slot="prefix" style="color:#009b43;" class="el-input__icon el-icon-search"></i>
          </el-input>
          <el-select
            v-model="modality"
            placeholder="检查类别"
            class="search_input"
            clearable
          >
            <el-option
              v-for="item in departmentOption"
              :key="item.desc"
              :label="item.desc"
              :value="item.desc"
            ></el-option>
          </el-select>
          <el-select
            v-model="partExamined"
            placeholder="检查部位"
            class="search_input"
            clearable
          >
            <el-option
              v-for="item in examinationSite"
              :key="item.id"
              :label="item.name"
              :value="item.value"
            ></el-option>
          </el-select>
          <el-select
            v-model="hospitalId"
            placeholder="检查医院"
            class="search_input"
            clearable
          >
            <el-option
              v-for="item in hospitallist"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
          <div class="box_cycle">
            <span
              v-for="(item, index) in cycle"
              :key="index"
              @click="cycleChoice(item.name, item.id)"
              :class="item.name == active ? 'active cyclestyle' : 'cyclestyle'"
            >
              {{ item.name }}
            </span>
            <span
              @click="dialogVisible = true"
              style="color:#3EAF6A;font-size:14px;cursor: pointer;width:90px;height:38px;display: flex;align-items: center;justify-content: center;"
            >
            <img style="width:15px;height:15px;" src="../../assets/日历@2x.png" alt="">
              更多
            </span>
          </div>
        </div>
        <div>
          <button
            type="primary"
            class="search_click"
            @click="getSearchList()"
            >搜索</button
          >
        </div>
      </div>
    </el-row>
    <!-- 打印弹窗 -->
    <el-dialog
      title="胶片打印"
      :visible.sync="cardPrint"
      width="70%"
      :before-close="handleClose"
    >
      <el-dialog
        width="30%"
        title="打印"
        :visible.sync="innerVisible"
        append-to-body
      >
        <div>
          <span style="width: 70px; display: inline-block">打印机：</span>
          <el-select
            v-model="printerId"
            placeholder="选择打印机"
            class="search_input"
            clearable
          >
            <el-option
              v-for="item in setUpList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </div>
        <div style="margin-top: 10px">
          胶片尺寸：
          <el-select
            v-model="size"
            placeholder="选择胶片尺寸"
            class="search_input"
            clearable
          >
            <el-option
              v-for="item in cardsize"
              :key="item.type"
              :label="item.desc"
              :value="item.type"
            ></el-option>
          </el-select>
        </div>
        <div style="margin-top: 10px">
          <span style="width: 70px; display: inline-block">方向：</span>
          <el-select
            v-model="orientation"
            placeholder="选择方向"
            class="search_input"
            clearable
          >
            <el-option
              v-for="item in carddirection"
              :key="item.type"
              :label="item.desc"
              :value="item.type"
            ></el-option>
          </el-select>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="carddoPrint">确 定</el-button>
        </span>
      </el-dialog>
      <!-- 打印设置 -->
      <el-dialog
        width="30%"
        title="打印设置"
        :visible.sync="printsetup"
        append-to-body
      >
        <el-form
          :model="formEditcard"
          :rules="rules"
          :inline="true"
          ref="formEditcard"
        >
          <!-- <el-form-item prop="content" label="公告内容:" :label-width="formLabelWidth">
          <el-input type="textarea" :row="3" placeholder="请输入公告内容" v-model="formEdit.content" autocomplete="off"></el-input>
        </el-form-item> -->
          <el-form-item
            prop="name"
            label="打印机名称:"
            :label-width="formLabelWidth"
          >
            <el-input
              placeholder="请输入打印机名称"
              v-model="formEditcard.name"
              autocomplete="off"
            ></el-input>
          </el-form-item>

          <el-form-item prop="ip" label="ip:" :label-width="formLabelWidth">
            <el-input
              placeholder="请输入ip"
              v-model="formEditcard.ip"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item prop="port" label="端口:" :label-width="formLabelWidth">
            <el-input
              placeholder="请输入端口"
              v-model="formEditcard.port"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item
            prop="aeTitle"
            label="AeTitle:"
            :label-width="formLabelWidth"
          >
            <el-input
              placeholder="请输入AeTitle"
              v-model="formEditcard.aeTitle"
              autocomplete="off"
            ></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="printsetup = false">取 消</el-button>
          <el-button type="primary" @click="clickcardsetUp">确 定</el-button>
        </span>
      </el-dialog>

      <div>
        <div style="display: flex">
          <div @click="innerVisible = true">打印</div>
          <div @click="printsetup = true" style="margin-left: 10px">
            打印设置
          </div>
        </div>
        <div>
        <div v-if="cardWidth == '1' && cardHeight == '1'" class="cardBox">
            <div
              class="cardimg1"
              style="position: relative"
              v-for="(item, index) in cardList"
              :key="index"
            >
              <img
                style="object-fit: contain; width: 100%; height: 100%"
                :src="item.imagePath"
                alt=""
              />
              <div class="cardimg_left">
                <p>姓名:{{ boxList.username }}</p>
                <p>年龄:{{ boxList.studyAge }}</p>
                <p>性别:{{ boxList.gender == "0" ? "男" : "女" }}</p>
                <p>Lat/Pos:{{ item.seriesDescription }}</p>
              </div>
              <div class="cardimg_right">
                <p>{{ item.times }}</p>
                <p>{{ item.seriesDescription }}</p>
              </div>
              <div class="cardimg_bottom">
                <p>W:{{ item.windowWidth }}</p>
                <p>L:{{ item.windowCenter }}</p>
              </div>
            </div>
          </div>
          <div v-if="cardWidth == '2' && cardHeight == '1'" class="cardBox">
            <div
              class="autocard_layout2"
              style="position: relative"
              v-for="(item, index) in cardList"
              :key="index"
            >
              <img
                style="object-fit: contain; width: 100%; height: 100%"
                :src="item.imagePath"
                alt=""
              />
              <div class="cardimg_left">
                <p>姓名:{{ boxList.username }}</p>
                <p>年龄:{{ boxList.studyAge }}</p>
                <p>性别:{{ boxList.gender == "0" ? "男" : "女" }}</p>
                <p>Lat/Pos:{{ item.seriesDescription }}</p>
              </div>
              <div class="cardimg_right">
                <p>{{ item.times }}</p>
                <p>{{ item.seriesDescription }}</p>
              </div>
              <div class="cardimg_bottom">
                <p>W:{{ item.windowWidth }}</p>
                <p>L:{{ item.windowCenter }}</p>
              </div>
            </div>
          </div>
           <div v-if="cardWidth == '3' && cardHeight == '1'" class="cardBox">
            <div
              class="autocard_layout3"
              style="position: relative"
              v-for="(item, index) in cardList"
              :key="index"
            >
              <img
                style="object-fit: contain; width: 100%; height: 100%"
                :src="item.imagePath"
                alt=""
              />
              <div class="cardimg_left">
                <p>姓名:{{ boxList.username }}</p>
                <p>年龄:{{ boxList.studyAge }}</p>
                <p>性别:{{ boxList.gender == "0" ? "男" : "女" }}</p>
                <p>Lat/Pos:{{ item.seriesDescription }}</p>
              </div>
              <div class="cardimg_right">
                <p>{{ item.times }}</p>
                <p>{{ item.seriesDescription }}</p>
              </div>
              <div class="cardimg_bottom">
                <p>W:{{ item.windowWidth }}</p>
                <p>L:{{ item.windowCenter }}</p>
              </div>
            </div>
          </div>
           <div v-if="cardWidth == '4' && cardHeight == '1'" class="cardBox">
            <div
              class="autocard_layout4"
              style="position: relative"
              v-for="(item, index) in cardList"
              :key="index"
            >
              <img
                style="object-fit: contain; width: 100%; height: 100%"
                :src="item.imagePath"
                alt=""
              />
              <div class="cardimg_left">
                <p>姓名:{{ boxList.username }}</p>
                <p>年龄:{{ boxList.studyAge }}</p>
                <p>性别:{{ boxList.gender == "0" ? "男" : "女" }}</p>
                <p>Lat/Pos:{{ item.seriesDescription }}</p>
              </div>
              <div class="cardimg_right">
                <p>{{ item.times }}</p>
                <p>{{ item.seriesDescription }}</p>
              </div>
              <div class="cardimg_bottom">
                <p>W:{{ item.windowWidth }}</p>
                <p>L:{{ item.windowCenter }}</p>
              </div>
            </div>
          </div>
           <div v-if="cardWidth == '5' && cardHeight == '1'" class="cardBox">
            <div
              class="autocard_layout5"
              style="position: relative"
              v-for="(item, index) in cardList"
              :key="index"
            >
              <img
                style="object-fit: contain; width: 100%; height: 100%"
                :src="item.imagePath"
                alt=""
              />
              <div class="cardimg_left">
                <p>姓名:{{ boxList.username }}</p>
                <p>年龄:{{ boxList.studyAge }}</p>
                <p>性别:{{ boxList.gender == "0" ? "男" : "女" }}</p>
                <p>Lat/Pos:{{ item.seriesDescription }}</p>
              </div>
              <div class="cardimg_right">
                <p>{{ item.times }}</p>
                <p>{{ item.seriesDescription }}</p>
              </div>
              <div class="cardimg_bottom">
                <p>W:{{ item.windowWidth }}</p>
                <p>L:{{ item.windowCenter }}</p>
              </div>
            </div>
          </div>
           <div v-if="cardWidth == '6' && cardHeight == '1'" class="cardBox">
            <div
              class="autocard_layout6"
              style="position: relative"
              v-for="(item, index) in cardList"
              :key="index"
            >
              <img
                style="object-fit: contain; width: 100%; height: 100%"
                :src="item.imagePath"
                alt=""
              />
              <div class="cardimg_left">
                <p>姓名:{{ boxList.username }}</p>
                <p>年龄:{{ boxList.studyAge }}</p>
                <p>性别:{{ boxList.gender == "0" ? "男" : "女" }}</p>
                <p>Lat/Pos:{{ item.seriesDescription }}</p>
              </div>
              <div class="cardimg_right">
                <p>{{ item.times }}</p>
                <p>{{ item.seriesDescription }}</p>
              </div>
              <div class="cardimg_bottom">
                <p>W:{{ item.windowWidth }}</p>
                <p>L:{{ item.windowCenter }}</p>
              </div>
            </div>
          </div>
           <div v-if="cardWidth == '1' && cardHeight == '2'" class="cardBox">
            <div
              class="autocard_layout7"
              style="position: relative"
              v-for="(item, index) in cardList"
              :key="index"
            >
              <img
                style="object-fit: contain; width: 100%; height: 100%"
                :src="item.imagePath"
                alt=""
              />
              <div class="cardimg_left">
                <p>姓名:{{ boxList.username }}</p>
                <p>年龄:{{ boxList.studyAge }}</p>
                <p>性别:{{ boxList.gender == "0" ? "男" : "女" }}</p>
                <p>Lat/Pos:{{ item.seriesDescription }}</p>
              </div>
              <div class="cardimg_right">
                <p>{{ item.times }}</p>
                <p>{{ item.seriesDescription }}</p>
              </div>
              <div class="cardimg_bottom">
                <p>W:{{ item.windowWidth }}</p>
                <p>L:{{ item.windowCenter }}</p>
              </div>
            </div>
          </div>
           <div v-if="cardWidth == '2' && cardHeight == '2'" class="cardBox">
            <div
              class="autocard_layout8"
              style="position: relative"
              v-for="(item, index) in cardList"
              :key="index"
            >
              <img
                style="object-fit: contain; width: 100%; height: 100%"
                :src="item.imagePath"
                alt=""
              />
              <div class="cardimg_left">
                <p>姓名:{{ boxList.username }}</p>
                <p>年龄:{{ boxList.studyAge }}</p>
                <p>性别:{{ boxList.gender == "0" ? "男" : "女" }}</p>
                <p>Lat/Pos:{{ item.seriesDescription }}</p>
              </div>
              <div class="cardimg_right">
                <p>{{ item.times }}</p>
                <p>{{ item.seriesDescription }}</p>
              </div>
              <div class="cardimg_bottom">
                <p>W:{{ item.windowWidth }}</p>
                <p>L:{{ item.windowCenter }}</p>
              </div>
            </div>
          </div>
           <div v-if="cardWidth == '3' && cardHeight == '2'" class="cardBox">
            <div
              class="autocard_layout9"
              style="position: relative"
              v-for="(item, index) in cardList"
              :key="index"
            >
              <img
                style="object-fit: contain; width: 100%; height: 100%"
                :src="item.imagePath"
                alt=""
              />
              <div class="cardimg_left">
                <p>姓名:{{ boxList.username }}</p>
                <p>年龄:{{ boxList.studyAge }}</p>
                <p>性别:{{ boxList.gender == "0" ? "男" : "女" }}</p>
                <p>Lat/Pos:{{ item.seriesDescription }}</p>
              </div>
              <div class="cardimg_right">
                <p>{{ item.times }}</p>
                <p>{{ item.seriesDescription }}</p>
              </div>
              <div class="cardimg_bottom">
                <p>W:{{ item.windowWidth }}</p>
                <p>L:{{ item.windowCenter }}</p>
              </div>
            </div>
          </div>
           <div v-if="cardWidth == '4' && cardHeight == '2'" class="cardBox">
            <div
              class="autocard_layout10"
              style="position: relative"
              v-for="(item, index) in cardList"
              :key="index"
            >
              <img
                style="object-fit: contain; width: 100%; height: 100%"
                :src="item.imagePath"
                alt=""
              />
              <div class="cardimg_left">
                <p>姓名:{{ boxList.username }}</p>
                <p>年龄:{{ boxList.studyAge }}</p>
                <p>性别:{{ boxList.gender == "0" ? "男" : "女" }}</p>
                <p>Lat/Pos:{{ item.seriesDescription }}</p>
              </div>
              <div class="cardimg_right">
                <p>{{ item.times }}</p>
                <p>{{ item.seriesDescription }}</p>
              </div>
              <div class="cardimg_bottom">
                <p>W:{{ item.windowWidth }}</p>
                <p>L:{{ item.windowCenter }}</p>
              </div>
            </div>
          </div>
           <div v-if="cardWidth == '5' && cardHeight == '2'" class="cardBox">
            <div
              class="autocard_layout11"
              style="position: relative"
              v-for="(item, index) in cardList"
              :key="index"
            >
              <img
                style="object-fit: contain; width: 100%; height: 100%"
                :src="item.imagePath"
                alt=""
              />
              <div class="cardimg_left">
                <p>姓名:{{ boxList.username }}</p>
                <p>年龄:{{ boxList.studyAge }}</p>
                <p>性别:{{ boxList.gender == "0" ? "男" : "女" }}</p>
                <p>Lat/Pos:{{ item.seriesDescription }}</p>
              </div>
              <div class="cardimg_right">
                <p>{{ item.times }}</p>
                <p>{{ item.seriesDescription }}</p>
              </div>
              <div class="cardimg_bottom">
                <p>W:{{ item.windowWidth }}</p>
                <p>L:{{ item.windowCenter }}</p>
              </div>
            </div>
          </div>
           <div v-if="cardWidth == '6' && cardHeight == '2'" class="cardBox">
            <div
              class="autocard_layout12"
              style="position: relative"
              v-for="(item, index) in cardList"
              :key="index"
            >
              <img
                style="object-fit: contain; width: 100%; height: 100%"
                :src="item.imagePath"
                alt=""
              />
              <div class="cardimg_left">
                <p>姓名:{{ boxList.username }}</p>
                <p>年龄:{{ boxList.studyAge }}</p>
                <p>性别:{{ boxList.gender == "0" ? "男" : "女" }}</p>
                <p>Lat/Pos:{{ item.seriesDescription }}</p>
              </div>
              <div class="cardimg_right">
                <p>{{ item.times }}</p>
                <p>{{ item.seriesDescription }}</p>
              </div>
              <div class="cardimg_bottom">
                <p>W:{{ item.windowWidth }}</p>
                <p>L:{{ item.windowCenter }}</p>
              </div>
            </div>
          </div>
           <div v-if="cardWidth == '1' && cardHeight == '3'" class="cardBox">
            <div
              class="autocard_layout13"
              style="position: relative"
              v-for="(item, index) in cardList"
              :key="index"
            >
              <img
                style="object-fit: contain; width: 100%; height: 100%"
                :src="item.imagePath"
                alt=""
              />
              <div class="cardimg_left">
                <p>姓名:{{ boxList.username }}</p>
                <p>年龄:{{ boxList.studyAge }}</p>
                <p>性别:{{ boxList.gender == "0" ? "男" : "女" }}</p>
                <p>Lat/Pos:{{ item.seriesDescription }}</p>
              </div>
              <div class="cardimg_right">
                <p>{{ item.times }}</p>
                <p>{{ item.seriesDescription }}</p>
              </div>
              <div class="cardimg_bottom">
                <p>W:{{ item.windowWidth }}</p>
                <p>L:{{ item.windowCenter }}</p>
              </div>
            </div>
          </div>
           <div v-if="cardWidth == '2' && cardHeight == '3'" class="cardBox">
            <div
              class="autocard_layout14"
              style="position: relative"
              v-for="(item, index) in cardList"
              :key="index"
            >
              <img
                style="object-fit: contain; width: 100%; height: 100%"
                :src="item.imagePath"
                alt=""
              />
              <div class="cardimg_left">
                <p>姓名:{{ boxList.username }}</p>
                <p>年龄:{{ boxList.studyAge }}</p>
                <p>性别:{{ boxList.gender == "0" ? "男" : "女" }}</p>
                <p>Lat/Pos:{{ item.seriesDescription }}</p>
              </div>
              <div class="cardimg_right">
                <p>{{ item.times }}</p>
                <p>{{ item.seriesDescription }}</p>
              </div>
              <div class="cardimg_bottom">
                <p>W:{{ item.windowWidth }}</p>
                <p>L:{{ item.windowCenter }}</p>
              </div>
            </div>
          </div>
           <div v-if="cardWidth == '3' && cardHeight == '3'" class="cardBox">
            <div
              class="autocard_layout15"
              style="position: relative"
              v-for="(item, index) in cardList"
              :key="index"
            >
              <img
                style="object-fit: contain; width: 100%; height: 100%"
                :src="item.imagePath"
                alt=""
              />
              <div class="cardimg_left">
                <p>姓名:{{ boxList.username }}</p>
                <p>年龄:{{ boxList.studyAge }}</p>
                <p>性别:{{ boxList.gender == "0" ? "男" : "女" }}</p>
                <p>Lat/Pos:{{ item.seriesDescription }}</p>
              </div>
              <div class="cardimg_right">
                <p>{{ item.times }}</p>
                <p>{{ item.seriesDescription }}</p>
              </div>
              <div class="cardimg_bottom">
                <p>W:{{ item.windowWidth }}</p>
                <p>L:{{ item.windowCenter }}</p>
              </div>
            </div>
          </div>
           <div v-if="cardWidth == '4' && cardHeight == '3'" class="cardBox">
            <div
              class="autocard_layout16"
              style="position: relative"
              v-for="(item, index) in cardList"
              :key="index"
            >
              <img
                style="object-fit: contain; width: 100%; height: 100%"
                :src="item.imagePath"
                alt=""
              />
              <div class="cardimg_left">
                <p>姓名:{{ boxList.username }}</p>
                <p>年龄:{{ boxList.studyAge }}</p>
                <p>性别:{{ boxList.gender == "0" ? "男" : "女" }}</p>
                <p>Lat/Pos:{{ item.seriesDescription }}</p>
              </div>
              <div class="cardimg_right">
                <p>{{ item.times }}</p>
                <p>{{ item.seriesDescription }}</p>
              </div>
              <div class="cardimg_bottom">
                <p>W:{{ item.windowWidth }}</p>
                <p>L:{{ item.windowCenter }}</p>
              </div>
            </div>
          </div>
           <div v-if="cardWidth == '5' && cardHeight == '3'" class="cardBox">
            <div
              class="autocard_layout17"
              style="position: relative"
              v-for="(item, index) in cardList"
              :key="index"
            >
              <img
                style="object-fit: contain; width: 100%; height: 100%"
                :src="item.imagePath"
                alt=""
              />
              <div class="cardimg_left">
                <p>姓名:{{ boxList.username }}</p>
                <p>年龄:{{ boxList.studyAge }}</p>
                <p>性别:{{ boxList.gender == "0" ? "男" : "女" }}</p>
                <p>Lat/Pos:{{ item.seriesDescription }}</p>
              </div>
              <div class="cardimg_right">
                <p>{{ item.times }}</p>
                <p>{{ item.seriesDescription }}</p>
              </div>
              <div class="cardimg_bottom">
                <p>W:{{ item.windowWidth }}</p>
                <p>L:{{ item.windowCenter }}</p>
              </div>
            </div>
          </div>
           <div v-if="cardWidth == '6' && cardHeight == '3'" class="cardBox">
            <div
              class="autocard_layout18"
              style="position: relative"
              v-for="(item, index) in cardList"
              :key="index"
            >
              <img
                style="object-fit: contain; width: 100%; height: 100%"
                :src="item.imagePath"
                alt=""
              />
              <div class="cardimg_left">
                <p>姓名:{{ boxList.username }}</p>
                <p>年龄:{{ boxList.studyAge }}</p>
                <p>性别:{{ boxList.gender == "0" ? "男" : "女" }}</p>
                <p>Lat/Pos:{{ item.seriesDescription }}</p>
              </div>
              <div class="cardimg_right">
                <p>{{ item.times }}</p>
                <p>{{ item.seriesDescription }}</p>
              </div>
              <div class="cardimg_bottom">
                <p>W:{{ item.windowWidth }}</p>
                <p>L:{{ item.windowCenter }}</p>
              </div>
            </div>
          </div>
           <div v-if="cardWidth == '1' && cardHeight == '4'" class="cardBox">
            <div
              class="autocard_layout19"
              style="position: relative"
              v-for="(item, index) in cardList"
              :key="index"
            >
              <img
                style="object-fit: contain; width: 100%; height: 100%"
                :src="item.imagePath"
                alt=""
              />
              <div class="cardimg_left">
                <p>姓名:{{ boxList.username }}</p>
                <p>年龄:{{ boxList.studyAge }}</p>
                <p>性别:{{ boxList.gender == "0" ? "男" : "女" }}</p>
                <p>Lat/Pos:{{ item.seriesDescription }}</p>
              </div>
              <div class="cardimg_right">
                <p>{{ item.times }}</p>
                <p>{{ item.seriesDescription }}</p>
              </div>
              <div class="cardimg_bottom">
                <p>W:{{ item.windowWidth }}</p>
                <p>L:{{ item.windowCenter }}</p>
              </div>
            </div>
          </div>
           <div v-if="cardWidth == '2' && cardHeight == '4'" class="cardBox">
            <div
              class="autocard_layout20"
              style="position: relative"
              v-for="(item, index) in cardList"
              :key="index"
            >
              <img
                style="object-fit: contain; width: 100%; height: 100%"
                :src="item.imagePath"
                alt=""
              />
              <div class="cardimg_left">
                <p>姓名:{{ boxList.username }}</p>
                <p>年龄:{{ boxList.studyAge }}</p>
                <p>性别:{{ boxList.gender == "0" ? "男" : "女" }}</p>
                <p>Lat/Pos:{{ item.seriesDescription }}</p>
              </div>
              <div class="cardimg_right">
                <p>{{ item.times }}</p>
                <p>{{ item.seriesDescription }}</p>
              </div>
              <div class="cardimg_bottom">
                <p>W:{{ item.windowWidth }}</p>
                <p>L:{{ item.windowCenter }}</p>
              </div>
            </div>
          </div>
           <div v-if="cardWidth == '3' && cardHeight == '4'" class="cardBox">
            <div
              class="autocard_layout21"
              style="position: relative"
              v-for="(item, index) in cardList"
              :key="index"
            >
              <img
                style="object-fit: contain; width: 100%; height: 100%"
                :src="item.imagePath"
                alt=""
              />
              <div class="cardimg_left">
                <p>姓名:{{ boxList.username }}</p>
                <p>年龄:{{ boxList.studyAge }}</p>
                <p>性别:{{ boxList.gender == "0" ? "男" : "女" }}</p>
                <p>Lat/Pos:{{ item.seriesDescription }}</p>
              </div>
              <div class="cardimg_right">
                <p>{{ item.times }}</p>
                <p>{{ item.seriesDescription }}</p>
              </div>
              <div class="cardimg_bottom">
                <p>W:{{ item.windowWidth }}</p>
                <p>L:{{ item.windowCenter }}</p>
              </div>
            </div>
          </div>
           <div v-if="cardWidth == '4' && cardHeight == '4'" class="cardBox">
            <div
              class="autocard_layout22"
              style="position: relative"
              v-for="(item, index) in cardList"
              :key="index"
            >
              <img
                style="object-fit: contain; width: 100%; height: 100%"
                :src="item.imagePath"
                alt=""
              />
              <div class="cardimg_left">
                <p>姓名:{{ boxList.username }}</p>
                <p>年龄:{{ boxList.studyAge }}</p>
                <p>性别:{{ boxList.gender == "0" ? "男" : "女" }}</p>
                <p>Lat/Pos:{{ item.seriesDescription }}</p>
              </div>
              <div class="cardimg_right">
                <p>{{ item.times }}</p>
                <p>{{ item.seriesDescription }}</p>
              </div>
              <div class="cardimg_bottom">
                <p>W:{{ item.windowWidth }}</p>
                <p>L:{{ item.windowCenter }}</p>
              </div>
            </div>
          </div>
           <div v-if="cardWidth == '5' && cardHeight == '4'" class="cardBox">
            <div
              class="autocard_layout23"
              style="position: relative"
              v-for="(item, index) in cardList"
              :key="index"
            >
              <img
                style="object-fit: contain; width: 100%; height: 100%"
                :src="item.imagePath"
                alt=""
              />
              <div class="cardimg_left">
                <p>姓名:{{ boxList.username }}</p>
                <p>年龄:{{ boxList.studyAge }}</p>
                <p>性别:{{ boxList.gender == "0" ? "男" : "女" }}</p>
                <p>Lat/Pos:{{ item.seriesDescription }}</p>
              </div>
              <div class="cardimg_right">
                <p>{{ item.times }}</p>
                <p>{{ item.seriesDescription }}</p>
              </div>
              <div class="cardimg_bottom">
                <p>W:{{ item.windowWidth }}</p>
                <p>L:{{ item.windowCenter }}</p>
              </div>
            </div>
          </div>
           <div v-if="cardWidth == '6' && cardHeight == '4'" class="cardBox">
            <div
              class="autocard_layout24"
              style="position: relative"
              v-for="(item, index) in cardList"
              :key="index"
            >
              <img
                style="object-fit: contain; width: 100%; height: 100%"
                :src="item.imagePath"
                alt=""
              />
              <div class="cardimg_left">
                <p>姓名:{{ boxList.username }}</p>
                <p>年龄:{{ boxList.studyAge }}</p>
                <p>性别:{{ boxList.gender == "0" ? "男" : "女" }}</p>
                <p>Lat/Pos:{{ item.seriesDescription }}</p>
              </div>
              <div class="cardimg_right">
                <p>{{ item.times }}</p>
                <p>{{ item.seriesDescription }}</p>
              </div>
              <div class="cardimg_bottom">
                <p>W:{{ item.windowWidth }}</p>
                <p>L:{{ item.windowCenter }}</p>
              </div>
            </div>
          </div>
           <div v-if="cardWidth == '1' && cardHeight == '5'" class="cardBox">
            <div
              class="autocard_layout25"
              style="position: relative"
              v-for="(item, index) in cardList"
              :key="index"
            >
              <img
                style="object-fit: contain; width: 100%; height: 100%"
                :src="item.imagePath"
                alt=""
              />
              <div class="cardimg_left">
                <p>姓名:{{ boxList.username }}</p>
                <p>年龄:{{ boxList.studyAge }}</p>
                <p>性别:{{ boxList.gender == "0" ? "男" : "女" }}</p>
                <p>Lat/Pos:{{ item.seriesDescription }}</p>
              </div>
              <div class="cardimg_right">
                <p>{{ item.times }}</p>
                <p>{{ item.seriesDescription }}</p>
              </div>
              <div class="cardimg_bottom">
                <p>W:{{ item.windowWidth }}</p>
                <p>L:{{ item.windowCenter }}</p>
              </div>
            </div>
          </div>
           <div v-if="cardWidth == '2' && cardHeight == '5'" class="cardBox">
            <div
              class="autocard_layout26"
              style="position: relative"
              v-for="(item, index) in cardList"
              :key="index"
            >
              <img
                style="object-fit: contain; width: 100%; height: 100%"
                :src="item.imagePath"
                alt=""
              />
              <div class="cardimg_left">
                <p>姓名:{{ boxList.username }}</p>
                <p>年龄:{{ boxList.studyAge }}</p>
                <p>性别:{{ boxList.gender == "0" ? "男" : "女" }}</p>
                <p>Lat/Pos:{{ item.seriesDescription }}</p>
              </div>
              <div class="cardimg_right">
                <p>{{ item.times }}</p>
                <p>{{ item.seriesDescription }}</p>
              </div>
              <div class="cardimg_bottom">
                <p>W:{{ item.windowWidth }}</p>
                <p>L:{{ item.windowCenter }}</p>
              </div>
            </div>
          </div>
           <div v-if="cardWidth == '3' && cardHeight == '5'" class="cardBox">
            <div
              class="autocard_layout27"
              style="position: relative"
              v-for="(item, index) in cardList"
              :key="index"
            >
              <img
                style="object-fit: contain; width: 100%; height: 100%"
                :src="item.imagePath"
                alt=""
              />
              <div class="cardimg_left">
                <p>姓名:{{ boxList.username }}</p>
                <p>年龄:{{ boxList.studyAge }}</p>
                <p>性别:{{ boxList.gender == "0" ? "男" : "女" }}</p>
                <p>Lat/Pos:{{ item.seriesDescription }}</p>
              </div>
              <div class="cardimg_right">
                <p>{{ item.times }}</p>
                <p>{{ item.seriesDescription }}</p>
              </div>
              <div class="cardimg_bottom">
                <p>W:{{ item.windowWidth }}</p>
                <p>L:{{ item.windowCenter }}</p>
              </div>
            </div>
          </div>
           <div v-if="cardWidth == '4' && cardHeight == '5'" class="cardBox">
            <div
              class="autocard_layout28"
              style="position: relative"
              v-for="(item, index) in cardList"
              :key="index"
            >
              <img
                style="object-fit: contain; width: 100%; height: 100%"
                :src="item.imagePath"
                alt=""
              />
              <div class="cardimg_left">
                <p>姓名:{{ boxList.username }}</p>
                <p>年龄:{{ boxList.studyAge }}</p>
                <p>性别:{{ boxList.gender == "0" ? "男" : "女" }}</p>
                <p>Lat/Pos:{{ item.seriesDescription }}</p>
              </div>
              <div class="cardimg_right">
                <p>{{ item.times }}</p>
                <p>{{ item.seriesDescription }}</p>
              </div>
              <div class="cardimg_bottom">
                <p>W:{{ item.windowWidth }}</p>
                <p>L:{{ item.windowCenter }}</p>
              </div>
            </div>
          </div>
           <div v-if="cardWidth == '5' && cardHeight == '5'" class="cardBox">
            <div
              class="autocard_layout29"
              style="position: relative"
              v-for="(item, index) in cardList"
              :key="index"
            >
              <img
                style="object-fit: contain; width: 100%; height: 100%"
                :src="item.imagePath"
                alt=""
              />
              <div class="cardimg_left">
                <p>姓名:{{ boxList.username }}</p>
                <p>年龄:{{ boxList.studyAge }}</p>
                <p>性别:{{ boxList.gender == "0" ? "男" : "女" }}</p>
                <p>Lat/Pos:{{ item.seriesDescription }}</p>
              </div>
              <div class="cardimg_right">
                <p>{{ item.times }}</p>
                <p>{{ item.seriesDescription }}</p>
              </div>
              <div class="cardimg_bottom">
                <p>W:{{ item.windowWidth }}</p>
                <p>L:{{ item.windowCenter }}</p>
              </div>
            </div>
          </div>
           <div v-if="cardWidth == '6' && cardHeight == '5'" class="cardBox">
            <div
              class="autocard_layout30"
              style="position: relative"
              v-for="(item, index) in cardList"
              :key="index"
            >
              <img
                style="object-fit: contain; width: 100%; height: 100%"
                :src="item.imagePath"
                alt=""
              />
              <div class="cardimg_left">
                <p>姓名:{{ boxList.username }}</p>
                <p>年龄:{{ boxList.studyAge }}</p>
                <p>性别:{{ boxList.gender == "0" ? "男" : "女" }}</p>
                <p>Lat/Pos:{{ item.seriesDescription }}</p>
              </div>
              <div class="cardimg_right">
                <p>{{ item.times }}</p>
                <p>{{ item.seriesDescription }}</p>
              </div>
              <div class="cardimg_bottom">
                <p>W:{{ item.windowWidth }}</p>
                <p>L:{{ item.windowCenter }}</p>
              </div>
            </div>
          </div>
           <div v-if="cardWidth == '1' && cardHeight == '6'" class="cardBox">
            <div
              class="autocard_layout31"
              style="position: relative"
              v-for="(item, index) in cardList"
              :key="index"
            >
              <img
                style="object-fit: contain; width: 100%; height: 100%"
                :src="item.imagePath"
                alt=""
              />
              <div class="cardimg_left">
                <p>姓名:{{ boxList.username }}</p>
                <p>年龄:{{ boxList.studyAge }}</p>
                <p>性别:{{ boxList.gender == "0" ? "男" : "女" }}</p>
                <p>Lat/Pos:{{ item.seriesDescription }}</p>
              </div>
              <div class="cardimg_right">
                <p>{{ item.times }}</p>
                <p>{{ item.seriesDescription }}</p>
              </div>
              <div class="cardimg_bottom">
                <p>W:{{ item.windowWidth }}</p>
                <p>L:{{ item.windowCenter }}</p>
              </div>
            </div>
          </div>
           <div v-if="cardWidth == '2' && cardHeight == '6'" class="cardBox">
            <div
              class="autocard_layout32"
              style="position: relative"
              v-for="(item, index) in cardList"
              :key="index"
            >
              <img
                style="object-fit: contain; width: 100%; height: 100%"
                :src="item.imagePath"
                alt=""
              />
              <div class="cardimg_left">
                <p>姓名:{{ boxList.username }}</p>
                <p>年龄:{{ boxList.studyAge }}</p>
                <p>性别:{{ boxList.gender == "0" ? "男" : "女" }}</p>
                <p>Lat/Pos:{{ item.seriesDescription }}</p>
              </div>
              <div class="cardimg_right">
                <p>{{ item.times }}</p>
                <p>{{ item.seriesDescription }}</p>
              </div>
              <div class="cardimg_bottom">
                <p>W:{{ item.windowWidth }}</p>
                <p>L:{{ item.windowCenter }}</p>
              </div>
            </div>
          </div>
           <div v-if="cardWidth == '3' && cardHeight == '6'" class="cardBox">
            <div
              class="autocard_layout33"
              style="position: relative"
              v-for="(item, index) in cardList"
              :key="index"
            >
              <img
                style="object-fit: contain; width: 100%; height: 100%"
                :src="item.imagePath"
                alt=""
              />
              <div class="cardimg_left">
                <p>姓名:{{ boxList.username }}</p>
                <p>年龄:{{ boxList.studyAge }}</p>
                <p>性别:{{ boxList.gender == "0" ? "男" : "女" }}</p>
                <p>Lat/Pos:{{ item.seriesDescription }}</p>
              </div>
              <div class="cardimg_right">
                <p>{{ item.times }}</p>
                <p>{{ item.seriesDescription }}</p>
              </div>
              <div class="cardimg_bottom">
                <p>W:{{ item.windowWidth }}</p>
                <p>L:{{ item.windowCenter }}</p>
              </div>
            </div>
          </div>
           <div v-if="cardWidth == '4' && cardHeight == '6'" class="cardBox">
            <div
              class="autocard_layout34"
              style="position: relative"
              v-for="(item, index) in cardList"
              :key="index"
            >
              <img
                style="object-fit: contain; width: 100%; height: 100%"
                :src="item.imagePath"
                alt=""
              />
              <div class="cardimg_left">
                <p>姓名:{{ boxList.username }}</p>
                <p>年龄:{{ boxList.studyAge }}</p>
                <p>性别:{{ boxList.gender == "0" ? "男" : "女" }}</p>
                <p>Lat/Pos:{{ item.seriesDescription }}</p>
              </div>
              <div class="cardimg_right">
                <p>{{ item.times }}</p>
                <p>{{ item.seriesDescription }}</p>
              </div>
              <div class="cardimg_bottom">
                <p>W:{{ item.windowWidth }}</p>
                <p>L:{{ item.windowCenter }}</p>
              </div>
            </div>
          </div>
           <div v-if="cardWidth == '5' && cardHeight == '6'" class="cardBox">
            <div
              class="autocard_layout35"
              style="position: relative"
              v-for="(item, index) in cardList"
              :key="index"
            >
              <img
                style="object-fit: contain; width: 100%; height: 100%"
                :src="item.imagePath"
                alt=""
              />
              <div class="cardimg_left">
                <p>姓名:{{ boxList.username }}</p>
                <p>年龄:{{ boxList.studyAge }}</p>
                <p>性别:{{ boxList.gender == "0" ? "男" : "女" }}</p>
                <p>Lat/Pos:{{ item.seriesDescription }}</p>
              </div>
              <div class="cardimg_right">
                <p>{{ item.times }}</p>
                <p>{{ item.seriesDescription }}</p>
              </div>
              <div class="cardimg_bottom">
                <p>W:{{ item.windowWidth }}</p>
                <p>L:{{ item.windowCenter }}</p>
              </div>
            </div>
          </div>
           <div v-if="cardWidth == '6' && cardHeight == '6'" class="cardBox">
            <div
              class="autocard_layout36"
              style="position: relative"
              v-for="(item, index) in cardList"
              :key="index"
            >
              <img
                style="object-fit: contain; width: 100%; height: 100%"
                :src="item.imagePath"
                alt=""
              />
              <div class="cardimg_left">
                <p>姓名:{{ boxList.username }}</p>
                <p>年龄:{{ boxList.studyAge }}</p>
                <p>性别:{{ boxList.gender == "0" ? "男" : "女" }}</p>
                <p>Lat/Pos:{{ item.seriesDescription }}</p>
              </div>
              <div class="cardimg_right">
                <p>{{ item.times }}</p>
                <p>{{ item.seriesDescription }}</p>
              </div>
              <div class="cardimg_bottom">
                <p>W:{{ item.windowWidth }}</p>
                <p>L:{{ item.windowCenter }}</p>
              </div>
            </div>
          </div>

           
           
        </div>
      </div>
    </el-dialog>
    <!-- 表格 -->
    <el-dialog
      title="时间选择"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose"
    >
      <el-date-picker
        v-model="value1"
        type="daterange"
        range-separator="至"
        value-format="timestamp"
        start-placeholder="开始日期"
        unlink-panels='true'
        end-placeholder="结束日期"
      >
      </el-date-picker>
      <span slot="footer" class="dialog-footer">
        <el-button class="login_Edit"  @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" class="ok_Edit" @click="dialogVisible = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      title="影像上传"
      :visible.sync="dicomePop"
      width="70%"
      :before-close="handleClose"
    >
      <div>
        <uploader @file-added="onFileAdded" :key="uploader_key" :options="optionster" class="uploader-example"
              @file-success="onFileSuccess">
      <uploader-unsupport></uploader-unsupport>
      <uploader-drop>
        <uploader-btn :directory="true" :single="true">选择文件夹</uploader-btn>
      </uploader-drop>
      <uploader-list></uploader-list>
    </uploader>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button class="login_Edit" @click="dicomePop = false">取 消</el-button>
        <el-button  class="ok_Edit" type="primary" @click="dicomePop = false">确 定</el-button>
      </span>
    </el-dialog>
    <el-table
      class="premission_table"
      :data="tableDatas"
      style="width: 100%"
      :header-cell-style="{background: '#F9F9F9',color:'#999999'}"
    >
      <el-table-column type="index" label="序号" width="50" />
      <el-table-column prop="studyNo" label="检查号" width="200" />
      <el-table-column prop="username" label="姓名" width="120" />
      <!-- <el-tab{
						label: '二维码',
						editLabel: '',
						model: 'qrcode',
						focus: false,
						style: {
							display: 'inline-block',
							border: 0,
							width: '100px',
							height: '100px',
							background: 'url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAASwAAAEsAQMAAABDsxw2AAAABlBMVEX///8AAABVwtN+AAABDElEQVRo3u3ZQQ7DIAwEwOTkZ+X/v8gzuLUIb+wYpNwqNfbuARGY3lY0tBvzFzk+nvGog9yWT7L8TGxYmXdlk77kg0bI8rLRhnZ1yDb3UQ+yGkyw/sh0iSwd081n1kNWiWnWSo2QJWaWyCyBWX3IErKema0BCyFLya6GtGuma/4i0ciSM0+LDIfDmOiTrod7CNmrmccLcxpDVQSbXh8IIUvKUBpd8k/hINGQJWf2qoiDxGYxR2TbTpaITTknOJhbfJQsKZtvlLeuYJesBtPBH53FL5LIuhCyF7LlryXE7wuReZHwqoGBrALD7H6QkJVhy69PK8OhsZPVYBpj8eJJlphZQkO8OmS1GfPDfAHsX5S+uaOtDgAAAABJRU5ErkJggg==) no-repeat',
							backgroundSize:'cover',
						},
					}le-column prop="gender" label="性别" /> -->
      <el-table-column prop="sex" label="性别" width="60">
        <template slot-scope="scope">
          {{ scope.row.gender == 0 ? "男" : "女" }}
        </template>
      </el-table-column>
      <el-table-column prop="studyAge" label="年龄" width="60" />
      <el-table-column prop="studyModality" label="检查类型" width="90" />
      <!-- <el-table-column prop="partExamined" label="检查部位" width="180"/> -->
      <el-table-column prop="status" label="检查部位" width="100">
        <template slot-scope="scope">
          <span v-if="scope.row.partExamined == 'BREAST'">乳腺</span>
          <span v-if="scope.row.partExamined == 'HEAD'">头部</span>
          <span v-if="scope.row.partExamined == 'NECK'">颈部</span>
          <span v-if="scope.row.partExamined == 'CHEST'">胸部</span>
          <span v-if="scope.row.partExamined == 'ABDOMEN'">腹部</span>
          <span v-if="scope.row.partExamined == 'UPPER EXTREMITIES'">上肢</span>
          <span v-if="scope.row.partExamined == 'LOWER EXTREMITIES'">下肢</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="status"
        v-if="regis_id == 1"
        label="检查状态"
        width="100"
      >
        <template slot-scope="scope">
          <span :class="scope.row.status == 0 ? 'statusone' : 'statustwo'">{{
            scope.row.status == 0 ? "未阅片" : "已阅片"
          }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="hospitalNames" label="检查医院" width="140" />
      <el-table-column prop="times" label="检查时间" width="170" />
      <el-table-column label="操作" fixed="right">
        <template slot-scope="scope">
          <el-button
            v-if="regis_id == 1 && scope.row.status == 0"
            type="text"
            @click.stop="() => edit(scope.row)"
            >查看</el-button
          >
          <el-button
            style="margin-left: 0px"
            v-if="scope.row.printStatus == 1"
            type="text"
            @click.stop="ClickcardPrint(scope.row.studyId)"
            >胶片打印</el-button
          >
          <p
            class="ningcolor"
            v-if="regis_id == 1 && scope.row.status == 1"
            @click.stop="() => warningclick(scope.row)"
          >
            报告
          </p>
          <!-- <button
           
            type="text"
            size="mini"
            @click.stop="() => edit(scope.row)"
            >登记</button -->
          <p
            class="ningcolor"
            v-if="regis_id == 0"
            @click.stop="() => edit(scope.row)"
          >
            登记
          </p>
          <!-- <el-button
            plain
            type="danger"
            size="mini"
            @click="deleteClick(scope.row)"
            >删除</el-button 
          > -->
        </template>
      </el-table-column>
    </el-table>
    <!-- 展示列表 -->
    <!-- 分页 -->
    <div class="pagination">
      <el-pagination
        background=""
        layout="prev, pager, next"
        :total="totalPage"
        :current-page.sync="currentPage"
        @current-change="getMenuLinkageList(currentPage)"
      />
    </div>
    <!-- 添加弹框 -->

    <!-- 编辑弹框 -->
    <el-dialog
      top="15vh"
      title=""
      :visible.sync="dialogFormVisibleEdit"
      width="60%"
      :close-on-click-modal="false"
    >
      <div><h2 class="tan_header">基本资料</h2></div>
      <el-form :model="formEdit" :rules="rules" :inline="true" ref="formEdit">
        <!-- <el-form-item prop="content" label="公告内容:" :label-width="formLabelWidth">
          <el-input type="textarea" :row="3" placeholder="请输入公告内容" v-model="formEdit.content" autocomplete="off"></el-input>
        </el-form-item> -->
        <el-form-item
          prop="username"
          label="患者姓名:"
          :label-width="formLabelWidth"
        >
          <el-input
            placeholder="请输入节点名称"
            v-model="formEdit.username"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item prop="gender" label="性别:" :label-width="formLabelWidth">
          <el-select v-model="formEdit.gender" placeholder="请选择菜单类型">
            <el-option label="男" value="0" />
            <el-option label="女" value="1" />
          </el-select>
        </el-form-item>
        <el-form-item
          prop="birthday"
          label="出生年月:"
          :label-width="formLabelWidth"
        >
          <el-date-picker
            v-model="formEdit.birthday"
            type="date"
            value-format="yyyy-MM-dd"
            format="yyyy-MM-dd"
            placeholder="选择日期"
          />
        </el-form-item>
        <el-form-item
          prop="studyAge"
          label="年龄:"
          :label-width="formLabelWidth"
        >
          <el-input
            placeholder="请输入年龄"
            v-model="formEdit.studyAge"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item
          prop="idcard"
          label="身份证号:"
          :label-width="formLabelWidth"
        >
          <el-input
            placeholder="请输入身份证号"
            v-model="formEdit.idcard"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item
          prop="phone"
          label="联系电话:"
          :label-width="formLabelWidth"
        >
          <el-input
            placeholder="请输入联系电话"
            v-model="formEdit.phone"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <div v-text="formEdit.selected2"></div>
        <el-form-item
          prop="area_code"
          label="地区:"
          class="area_box"
          :label-width="formLabelWidth"
        >
          <area-cascader
            type="text"
            v-model="formEdit.selected2"
            :data="pca"
          ></area-cascader>
        </el-form-item>
        <el-form-item
          prop="street"
          label="详细地址:"
          :label-width="formLabelWidth"
        >
          <el-input
            width="200"
            placeholder="请输入详细地址"
            v-model="formEdit.street"
            autocomplete="off"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisibleEdit = false">取 消</el-button>
        <el-button type="primary" @click="postFormEdit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { pca, pcaa } from "area-data";
import VuePdfApp from "vue-pdf-app";
// import this to use default icons for buttons
import "vue-pdf-app/dist/icons/main.css";
// import { addAnnounce, deleteAnnounce, editAnnounce, announceList } from '@/api/shop.js'

export default {
  components: {
    VuePdfApp,
  },
  name: "upload",
  data() {
    return {
      uploader_key: new Date().getTime(),//这个用来刷新组件--解决不刷新页面连续上传的缓存上传数据（注：每次上传时，强制这个值进行更改---根据自己的实际情况重新赋值）
    optionster: {
      target: this.GLOBAL.UPLOAD_URL + "v1/study/uploadDcm?token=" + sessionStorage.getItem('token'),//SpringBoot后台接收文件夹数据的接口
      chunkSize:1024*1024*10000,
      testChunks: false,//是否分片-不分片
    },
      itemmm:'',
      ffter:true,
      ffterr:true,
      activef:false,
      activeff:false,
      cardWidth: "",
      cardHeight: "",
      orientation: "",
      size: "",
      printerId: "",
      fileList: [],
      cardsize: [],
      carddirection: [],
      dialogVisible: false,
      printsetup: false,
      dicomePop: false,
      innerVisible: false,
      cardPrint: false,
      value1: [],
      checkUrl: "",
      pdfUrl: "",
      selected2: "",
      selected: [], //数组对应的就是选中的那个省市区。根据type来确定是省市区汉字的数组还是编码组成的数组。           //selected[0]省。selected[1]市。selected[2]区。
      pca: pca,
      pcaa: pcaa,
      area_code_array: "",
      times: "",
      regisactive: "未登记",
      regis_id: "0",
      register: [
        {
          name: "未登记",
          id: 0,
        },
        {
          name: "已登记",
          id: 1,
        },
      ],
      day: "3",
      active: "一周内",
      cycle: [
        {
          name: "今天",
          id: 1,
        },
        {
          name: "三天内",
          id: 2,
        },
        {
          name: "一周内",
          id: 3,
        },
      ],
      hospitallist: "",
      partExamined: "",
      hospitalId: "",
      modality: "",
      departmentOption: [
       
      ],
      examinationSite: [
        {
          name: "头部",
          id: 1,
          value: "HEAD",
        },
        {
          name: "颈部",
          id: 2,
          value: "NECK",
        },
        {
          name: "胸部",
          id: 3,
          value: "CHEST",
        },
        {
          name: "腹部",
          id: 4,
          value: "ABDOMEN",
        },
        {
          name: "乳腺",
          id: 5,
          value: "BREAST",
        },
        {
          name: "上肢",
          id: 6,
          value: "UPPER EXTREMITIES",
        },
        {
          name: "下肢",
          id: 7,
          value: "LOWER EXTREMITIES",
        },
      ],
      listlist: "",
      keysEdit: [],
      boxList: [],
      tableDatas: [],
      studyNo: "",
      menuList: "",
      propd: {
        multiple: true,
        label: "name",
        value: "id",
      },
      optionss: [
        {
          value: 1,
          label: "东南",
          children: [
            {
              value: 2,
              label: "上海",
              children: [
                { value: 3, label: "普陀" },
                { value: 4, label: "黄埔" },
                { value: 5, label: "徐汇" },
              ],
            },
            {
              value: 7,
              label: "江苏",
              children: [
                { value: 8, label: "南京" },
                { value: 9, label: "苏州" },
                { value: 10, label: "无锡" },
              ],
            },
            {
              value: 12,
              label: "浙江",
              children: [
                { value: 13, label: "杭州" },
                { value: 14, label: "宁波" },
                { value: 15, label: "嘉兴" },
              ],
            },
          ],
        },
        {
          value: 17,
          label: "西北",
          children: [
            {
              value: 18,
              label: "陕西",
              children: [
                { value: 19, label: "西安" },
                { value: 20, label: "延安" },
              ],
            },
            {
              value: 21,
              label: "新疆维吾尔族自治区",
              children: [
                { value: 22, label: "乌鲁木齐" },
                { value: 23, label: "克拉玛依" },
              ],
            },
          ],
        },
      ],
      propss: {
        multiple: true,
        children: "children",
        checkStrictly: true,
        label: "name",
        value: "name",
      },
      isAllSelect: false,
      keys: [],
      defaultProps: {
        children: "children",
        label: "name",
      },
      pstlist: "",
      permissionOptions: [],
      checkList: "",
      options: "",
      username: "",
      setUpList: [],
      totalPage: 0,
      currentPage: 1,
      cardList: [],
      tableData: [],
      dialogFormVisible: false,
      dialogFormVisibleEdit: false,
      formLabelWidth: "120px",
      list: "",
      formEditlist: [],
      formEditcard: {
        name: "",
        ip: "",
        port: "",
        aeTitle: "",
      },
      formEdit: {
        id: "",
        // content:"",
        // visible: "",
        // index: "",
        hospitalIds: "",
        // url: "",
        // icon: "",
        username: "",
        idcard: "",
        phone: "",
        street: "",
        selected2: "",
        studyAge: "",
        grade: "",
        gender: "",
        birthday: "",
        pid: "",
        remark: "",
        pstlist: "",
        permissions: "",
      },
      rules: {
        username: [
          { required: true, message: "请输入患者姓名", trigger: "blur" },
        ],
        idcard: [
          { required: true, message: "请输入身份证号", trigger: "blur" },
        ],
        phone: [{ required: true, message: "请输入联系电话", trigger: "blur" }],
        street: [
          { required: true, message: "请输入详细地址", trigger: "blur" },
        ],
        // studyAge: [{ required: true, message: "请输入患者年龄", trigger: "blur" }],
        gender: [{ required: true, message: "请选择性别", trigger: "blur" }],
      },
    };
  },
  created() {
    this.getCdlist();
    // this.getMenuLinkageList();
    this.getMenuLinkageList();
    this.getPermissionList();
    // 获取医院权限列表 搜索用
    this.getListMyHospital();
    this.getprinter();
    //打印尺寸
    this.$http
      .get(
        this.GLOBAL.BASE_URL + "v1/study/printdata/listFilmSizes?token=" +
          sessionStorage.getItem("token")
      )
      .then((response) => {
        console.log("response", response);
        this.cardsize = response.data.data;
      })
      .catch((err) => {
        console.error(err);
      });
    //打印方向
    this.$http
      .get(
        this.GLOBAL.BASE_URL + "v1/study/printdata/listFilmOrientation?token=" +
          sessionStorage.getItem("token")
      )
      .then((response) => {
        console.log("response", response);
        this.carddirection = response.data.data;
      })
      .catch((err) => {
        console.error(err);
      });

          depot
        .get({
          url: "/v1/devices/types",
          params: {
            token: sessionStorage.getItem("token"),
          },
        })
        .then((res) => {
          this.departmentOption = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
  },
  watch: {
    formEditlist(newVal) {
      this.formEdit.hospitalIds = newVal.join();
      console.log(this.formEdit.hospitalIds);
    },
    list(newVal) {
      this.form.hospitalIds = newVal.join();
      console.log(this.form.hospitalIds);
    },
  },
  methods: {
    onFileAdded(file){
      console.error('file',file.relativePath.slice(-3));
      if(file.relativePath.slice(-3) !='dcm'){
        // EventBus.$emit('alert.show', {type: 'warning', msg: `只能上传.dcm格式的文件`});
        file.ignored = true//文件校验，不符规则的文件过滤掉
      }
    },
    onFileSuccess: function (rootFile, file, response, chunk) {
        //这里可以根据response（接口）返回的数据处理自己的实际问题（如：从response拿到后台返回的想要的数据进行组装并显示）
        //注，这里从文件夹每上传成功一个文件会调用一次这个方法
  },
    visibilityChange(val) {
    let _len = val.length
    return val.substring(0, 1) + '****' + val.substring(_len - 1, _len)
},
    f(){
      console.log('123');
      this.ffter = false;
      this.activef = true;
    },
    blurUsername(){
      console.log('222');
      this.ffter = true;
      this.activef = false;
    },
    fr(){
      console.log('123');
      this.ffterr = false;
      this.activeff = true;
    },
    blurUsernamer(){
      console.log('222');
      this.ffterr = true;
      this.activeff = false;
    },
    addrecordclick(){
        this.$router.push({
        path: "/study/record/addinformation",
       
      });
    },
    getprinter() {
      this.$http
        .get(
          this.GLOBAL.BASE_URL + "v1/study/printer?token=" +
            sessionStorage.getItem("token")
        )
        .then((response) => {
          this.setUpList = response.data.data.list;
          console.error("responsedayinji", response);
        })
        .catch((err) => {
          console.error(err);
        });
    },
    clickcardsetUp() {
      this.http
        .post(
          this.GLOBAL.BASE_URL + "v1/study/printer?token=" +
            sessionStorage.getItem("token"),
          this.formEditcard
        )
        .then((response) => {
          console.log(response);
          if (response.data.code == 200) {
            this.$message({
              message: "新增打印机成功",
              type: "success",
            });
            this.printsetup = false;
            this.getprinter();
            return;
          }
          this.$message({
            message: response.data.msg,
            type: "error",
          });
          // this.$refs["upload"].$refs["upload-inner"].handleChangeedit()
        })
        .catch((err) => {
          console.error(err);
        });
    },
    carddoPrint() {
      const fordoprint = {
        studyId: this.studyId,
        printerId: this.printerId,
        orientation: this.orientation,
        size: this.size,
      };
      this.http
        .post(
          this.GLOBAL.BASE_URL + "v1/study/printdata/doPrint?token=" +
            sessionStorage.getItem("token"),
          fordoprint
        )
        .then((response) => {
          if (response.data.code == 200) {
            const datalist = {
              data: response.data.data,
            };
            this.http
              .post(
                "http://localhost:9091/v1/study/film/doPrint?token=" +
                  sessionStorage.getItem("token"),
                datalist
              )
              .then((response) => {
                console.log("datadata", response.data.data);
                if (response.data.code == 200) {
                  this.$message({
                    message: "打印任务发送成功",
                    type: "success",
                  });
                  this.innerVisible = false;
                  return;
                }
                this.$message({
                  message: response.data.msg,
                  type: "error",
                });
                // this.$refs["upload"].$refs["upload-inner"].handleChangeedit()
              })
              .catch((err) => {
                console.error(err);
              });
          }
          // this.$refs["upload"].$refs["upload-inner"].handleChangeedit()
        })
        .catch((err) => {
          console.error(err);
        });
    },
    ClickcardPrint(id) {
      this.cardPrint = true;
      console.log(id);
      this.studyId = id;
      this.$http
        .get(
          this.GLOBAL.BASE_URL + "v1/study/printdata/" +
            id +
            "?token=" +
            sessionStorage.getItem("token")
        )
        .then((response) => {
          this.cardList = response.data.data.list;
          this.boxList = response.data.data;
          this.cardList.forEach((item) => {
            item.times = this.time(item.seriesDateTime);
          });
          this.cardWidth = response.data.data.options.width;
          this.cardHeight = response.data.data.options.height;
          // console.error('this.cardList',response.data.data.options.width);
        })
        .catch((err) => {
          console.error(err);
        });
    },
    chooseFiles(e) {
      document.getElementById("file").click();
    },
    handleChangeedit(item, fileList) {
      console.error(
        "this.$refs.uploadFile",
        (document.getElementsByClassName(
          "upload-files"
        )[0].webkitdirectory = true)
      );
      // this.fileList = fileList
      let formData = new FormData();
      let file = item.raw;
      console.log("file", file);
      formData.append("file", file);
      formData.append("token", sessionStorage.getItem("token"));
      console.log("formData", formData);
      this.http
        .post(this.GLOBAL.BASE_URL + "v1/study/uploadDcm", formData)
        .then((response) => {
          console.log(response);
          if (response.data.code == 200) {
            // this.formEdit.fileId = response.data.data.id
            // this.filesId.push(response.data.data.id)
            // console.log('response',this.filesId)
            this.$message({
              message: "上传成功",
              type: "success",
            });
            return;
          }
          this.$message({
            message: response.data.msg,
            type: "error",
          });
          // this.$refs["upload"].$refs["upload-inner"].handleChangeedit()
        })
        .catch((err) => {
          console.error(err);
        });
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          done();
        })
        .catch((_) => {});
    },
    warningclick(row) {
      console.log(row);
      let { href } = this.$router.resolve({
        path: "/historyRecord",
        query: {
          id: row.studyId,
        },
      });
      window.open(href, "_blank");
    },
    registerclick(name, id, page = 1, page_num = 10) {
      this.regisactive = name;
      this.regis_id = id;
      depot
        .get({
          url: "/v1/study/listStudies",
          params: {
            page: page,
            pageSize: page_num,
            token: sessionStorage.getItem("token"),
            // username:this.username,
            // studyNo:this.studyNo,
            // modality:this.modality,
            // partExamined:this.partExamined,
            // hospitalId:this.hospitalId,
            day: this.day,
            status: this.regis_id,
            startTime: this.value1[0],
            endTime: this.value1[1],
          },
        })
        .then((res) => {
          console.log(res);
          this.totalPage = (res.data.count / page_num) * 10;
          this.tableDatas = res.data.list;
          console.log(this.tableDatas);
          this.tableDatas.forEach((element) => {
            console.log(this.time(element.studyDatetime));
            element.times = this.time(element.studyDatetime);
            element.hospitalNames = this.visibilityChange(element.hospitalName);
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    cycleChoice(name, id) {
      this.active = name;
      console.log(id);
      this.day = id;
    },
    getListMyHospital() {
      depot
        .get({
          url: "/v1/hospital/listMyHospital",
          params: {
            token: sessionStorage.getItem("token"),
          },
        })
        .then((res) => {
          this.hospitallist = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getMenuIdsEdit() {
      // let menuIds = this.$refs.menusTree.getCheckedKeys()
      // this.roleForm.menu_ids = menuIds
      if (Array.isArray(this.$refs.menusTreeEdit.getCheckedKeys())) {
        this.formEdit.permissions = this.$refs.menusTreeEdit
          .getCheckedKeys()
          .join();
      }
      console.log(this.formEdit.permissions);
    },
    getCdlist() {
      depot
        .post({
          url: "/backend/menu/getMenus",
          data: {},
        })
        .then((res) => {
          console.log(res);
          this.tableData = res.data;
          console.log(this.tableData);
          this.menuList = JSON.parse(JSON.stringify(res.data));
          // this.options.forEach((val, index) => {
          //   val.children.forEach((valus, index) => {
          //     delete valus.children;
          //   });
          //   // delete val.children
          // });
          console.log(this.menuList);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    edit(data) {
      // let { type, id, parent_id, title, icon, path, vue_route, permissions } = data
      console.log(data);
      this.$router.push({
        path: "/study/record/add",
        query: {
          userId: data.studyId,
          page: this.currentPage,
          username: this.username,
          studyNo: this.studyNo,
          modality: this.modality,
          partExamined: this.partExamined,
          hospitalId: this.hospitalId,
          day: this.day,
          status: this.regis_id,
          startTime: this.value1[0],
          endTime: this.value1[1],
        },
      });
      // this.dialogFormVisibleEdit = true;
      // this.formEdit = data;
      // this.formEditlist = data.hospitalIds.split(",");
      // var str = "";
      // var arrays = "";
      // data.permissions.map((item) => {
      //   str = str + item.menuId + ",";
      // });
      // str =
      //   str.substring(str.length - 1) == ","
      //     ? str.substring(0, str.length - 1)
      //     : str;
      // console.log(str);
      // this.keysEdit = str.split(",").map(Number);
      // this.formEdit.permissions = str.split(",").map(Number).join();
      // console.log(this.keysEdit);
      // console.error(this.formEdit.permissions);
      // console.log(data.permissions);
      // this.formEditlist = arr.map(item => item.split(':'))
      // this.formEdit.pstlist = data.permissions;
      // console.log(this.formEdit);
      // depot
      //   .get({
      //     url: "/v1/study/getStudy",
      //     params: {
      //       token: sessionStorage.getItem("token"),
      //       id: data.studyId,
      //     },
      //     config: {},
      //   })
      //   .then((res) => {
      //     console.log(res);
      //     this.formEdit = res.data;
      //   });
      // menuDetail({
      //   sign: '111',
      //   token: sessionStorage.getItem('token'),
      //   id: data.id
      // })
      //   .then(res => {
      //     this.editForm = res.data
      //     this.editForm.sign = '111'
      //     this.editForm.token = sessionStorage.getItem('token')
      //   })
      //   .catch(err => {
      //     console.log(err)
      //   })
      // this.getMenuLinkageList(data.type)
    },
    getMenuIds() {
      // let menuIds = this.$refs.menusTree.getCheckedKeys()
      // this.roleForm.permissions = menuIds
      if (Array.isArray(this.$refs.menusTree.getCheckedKeys())) {
        console.log(this.$refs.menusTree.getCheckedKeys());
        this.form.permissions = this.$refs.menusTree.getCheckedKeys().join();
      }
      console.log(this.form.permissions);
    },
    deleteClick(val) {
      console.log(val);
      depot
        .post({
          url: "/backend/role/delete",
          data: {
            id: val.id,
          },
        })
        .then((res) => {
          console.log(res);
          if (res.success == true) {
            this.$message({
              message: "删除成功",
              type: "success",
            });
            this.getMenuLinkageList();
            return;
          }
          this.$message({
            message: res.msg,
            type: "error",
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    time(time = +new Date()) {
      var date = new Date(time + 8 * 3600 * 1000);
      return date.toJSON().substr(0, 19).replace("T", " ").replace(/-/g, "-");
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.title.indexOf(value) !== -1;
    },
    handleChange() {
      console.log(this.value);
    },
    getMenuLinkageList(page = 1, page_num = 10) {
      // console.log(value);
      depot
        .get({
          url: "/v1/study/listStudies",
          params: {
            page: page,
            pageSize: page_num,
            token: sessionStorage.getItem("token"),
            day: this.day,
            status: this.regis_id,
            startTime: this.value1[0],
            endTime: this.value1[1],
            hospitalId:this.hospitalId,
            partExamined:this.partExamined,
            modality:this.modality,
            studyNo:this.studyNo,
            username:this.username,
          },
        })
        .then((res) => {
          console.log(res);
          this.totalPage = (res.data.count / page_num) * 10;
          console.error(this.totalPage);
          this.tableDatas = res.data.list;
          console.log(this.tableDatas);
          this.tableDatas.forEach((element) => {
            console.log(this.time(element.studyDatetime));
            element.times = this.time(element.studyDatetime);
            element.hospitalNames = this.visibilityChange(element.hospitalName);
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getPermissionList(value) {
      // console.log(value);
      depot
        .get({
          url: "/v1/hospital/listHospital",
          params: {
            token: sessionStorage.getItem("token"),
          },
        })
        .then((res) => {
          console.log(res.data);
          this.permissionOptions = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getSearchList(page = 1, page_num = 10) {
      depot
        .get({
          url: "/v1/study/listStudies",
          params: {
            page: page,
            pageSize: page_num,
            token: sessionStorage.getItem("token"),
            username: this.username,
            studyNo: this.studyNo,
            modality: this.modality,
            partExamined: this.partExamined,
            hospitalId: this.hospitalId,
            day: this.day,
            status: this.regis_id,
            startTime: this.value1[0],
            endTime: this.value1[1],
          },
        })
        .then((res) => {
          console.log(res);
          this.totalPage = (res.data.count / page_num) * 10;
          this.tableDatas = res.data.list;
          console.log(this.tableDatas);
          this.tableDatas.forEach((element) => {
            console.log(this.time(element.studyDatetime));
            element.times = this.time(element.studyDatetime);
            element.hospitalNames = this.visibilityChange(element.hospitalName);
          });
          this.currentPage = 1;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    postForm() {
      console.log(this.list);
      //  this.form.permissions.forEach((val, index) => {
      //       console.log(val);
      //       // delete val.children
      // });
      // let str = "";
      // for (var i = 0; i < this.permissions.length; i++) {
      //   str += this.permissions[i] + "|";
      //   var newlist = str.replace(/\,/g, ":");
      //   this.form.permissions = newlist.replace(/\|/g, ",");
      //   // this.form.permissions = this.form.permissions.substr(0,this.form.permissions.length-1);
      //   console.log(this.form.permissions);
      // }
      // this.form.hospitalIds = this.list.map(item => item.join(':')).join(',');
      // console.log(this.list.map(item => item.join(':')).join(','));
      // console.log(this.form.hospitalIds);
      this.$refs["form"].validate((valid) => {
        if (valid) {
          depot
            .post({
              url: "/backend/role/save",
              data: this.form,
            })
            .then((res) => {
              console.log(res);
              if (res.success == true) {
                this.$message({
                  message: "添加成功",
                  type: "success",
                });
                this.dialogFormVisible = false;
                this.getMenuLinkageList();
                return;
              }
              this.$message({
                message: "新增失败",
                type: "error",
              });
            })
            .catch((err) => {
              console.log(err);
            });
          // addAnnounce(this.form).then(res => {
          //   this.$message({
          //     message:res.message,
          //     type:"success",
          //     duration:2000
          //   })
          //   this.dialogFormVisible = false;
          //   this.getMenuLinkageList(this.currentPage);
          //   this.$refs["form"].resetFields();
          // }).catch(err => {
          //   console.log(err)
          // })
        }
      });
    },
    handleDelete(row) {
      this.$confirm("是否确认删除?", "警告", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          deleteAnnounce({
            id: row.id,
          })
            .then((res) => {
              this.getMenuLinkageList(this.currentPage);
            })
            .catch((err) => {
              console.log(err);
            });
        })
        .catch(() => {});
    },
    handleEdit(row) {
      let {
        id,
        username,
        idcard,
        selected2,
        phone,
        street,
        studyAge,
        grade,
        pid,
        remark,
        gender,
        birthday,
      } = row;
      this.formEdit.id = id;
      // this.formEdit.content = content
      this.formEdit.username = username;
      this.formEdit.idcard = idcard;
      this.formEdit.phone = phone;
      this.formEdit.street = street;
      this.formEdit.selected2 = selected2;
      this.formEdit.studyAge = studyAge;
      this.formEdit.pid = pid;
      this.formEdit.remark = remark;
      // this.formEdit.pstlist = pstlist;
      // this.formEdit.pstlist = permissions;
      // this.formEdit.visible = visible;
      // this.formEdit.index = index;
      // this.formEdit.url = url;
      this.formEdit.grade = grade;
      this.formEdit.gender = gender;
      this.formEdit.birthday = birthday;
      this.dialogFormVisibleEdit = true;
    },
    postFormEdit() {
      console.error(this.formEdit.permissions);
      // this.formEdit.hospitalIds = this.formEditlist.map(item => item.join(':')).join(',');
      // console.log(this.formEditlist.map(item => item.join(':')).join(','));
      // console.log(this.formEdit.hospitalIds);
      this.$refs["formEdit"].validate((valid) => {
        if (valid) {
          depot
            .post({
              url: "/backend/role/update",
              data: this.formEdit,
            })
            .then((res) => {
              console.log(res);
              if (res.success == true) {
                this.$message({
                  message: res.data,
                  type: "success",
                });
                this.dialogFormVisibleEdit = false;
                this.getMenuLinkageList();
                return;
              }
              this.$message({
                message: "修改失败",
                type: "error",
              });
            })
            .catch((err) => {
              console.log(err);
            });
          // editAnnounce(this.formEdit)
          //   .then((res) => {
          //     this.$message({
          //       message: res.message,
          //       type: "success",
          //       duration: 2000,
          //     });
          //     this.dialogFormVisibleEdit = false;
          //     this.getMenuLinkageList(this.currentPage);
          //     this.$refs["formEdit"].resetFields();
          //   })
          //   .catch((err) => {
          //     console.log(err);
          //   });
        }
      });
    },
  },
};
</script>

<style scoped lang="less">
.ningcolor {
  color: #e6a23c;
  cursor: pointer;
  font-weight: 500;
}
.tan_header {
  margin-left: 40px;
  margin-bottom: 15px;
}
/deep/.area_box .area-select .area-selected-trigger {
  padding: 0px 10px !important;
}
.search_click {
  color:#fff;
  width: 100px;
  height: 40px;
  background: #009b43;
  border: none;
    -o-transition: all .4s ease-in-out;
    -webkit-transition: all .4s ease-in-out;
    transition: all .4s ease-in-out;
    border-radius: 3px;
}
.search_click:hover {
  border-radius: 3px;
  background-image: linear-gradient(to right, #0ba360, #3cba92, #30dd8a, #2bb673);
  box-shadow: 0 4px 15px 0 rgba(23, 168, 108, 0.75);
   background-position: 100% 0;
    -o-transition: all .4s ease-in-out;
    -webkit-transition: all .4s ease-in-out;
    transition: all .4s ease-in-out;
}
.box_cycle {
  display: inline-flex;
  align-items: center;
  border: 1px solid #DDDDDD;
  border-radius: 3px;
}
.box_regis {
  /* border-bottom: 1px solid #EEEEEE; */
  display: inline-flex;
  /* margin-bottom: 28px; */
}
.box_cycle span:first-child {
  border-top-left-radius: 3px;
  border-bottom-left-radius: 3px;
  border-right: 1px solid #DDDDDD;
}
.box_cycle span:nth-child(3){
   border-left: 1px solid #DDDDDD;
}
.box_cycle span:last-child {
  border-top-right-radius: 3px;
  border-bottom-right-radius: 3px;
  border-left: 1px solid #DDDDDD;
}
.premission_index {
  position: relative;
  padding: 20px;
  background: #fff;
  margin-top: 10px;
  box-sizing: border-box;
}
.add {
  position: fixed;
  right: 20px;
  top:88px;
  font-size: 16px;
  width: 120px;
  font-weight: 400;
  height: 40px;
  background: #009b43;
  border: none;
  color: #fff;
   moz-transition: all .4s ease-in-out;
    -o-transition: all .4s ease-in-out;
    -webkit-transition: all .4s ease-in-out;
    transition: all .4s ease-in-out;
    border-radius: 3px;
}

.add:hover {
  border-radius: 3px;
  background-image: linear-gradient(to right, #0ba360, #3cba92, #30dd8a, #2bb673);
  box-shadow: 0 4px 15px 0 rgba(23, 168, 108, 0.75);
   background-position: 100% 0;
    -o-transition: all .4s ease-in-out;
    -webkit-transition: all .4s ease-in-out;
    transition: all .4s ease-in-out;
}
.search_div {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.search_input {
  width: 120px;
}
.premission_table {
  margin-top: 10px;
}
.pagination_box {
}
.pagination {
  padding: 0 20px;
  margin-top: 20px;
  text-align: right;
}
.elAdd {
  margin-bottom: 10px;
}
.elAddBox {
  width: 100%;
display: flex;
align-items: center;
justify-content: space-between;
border-bottom: 1px solid #eee;
margin-bottom: 19px;
}
.cyclestyle {
  cursor: pointer;
  width: 90px;
  height: 38px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #999999;
  background: #fff;
  font-size: 14px;
  opacity: 0.8;
}
.active {
  background: #009b43;
  cursor: pointer;
  color: #fff;
}
.register {
  cursor: pointer;
  /* width: 139px; */
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #333333;
  margin-right: 60px;
  font-weight: 500;
  /* background: #c4c4c4; */
  font-size: 14px;
  opacity: 0.8;
}
/* 
 */
.registeractive {
  cursor: pointer;
  color: #3EAF6A;
  border-bottom: 3px solid #3EAF6A;
  background: transparent!important;;
}
.statusone {
  color: #ed6f00 !important;
}
/deep/.pagination .btn-prev {
  display: none !important;
}
/deep/.pagination .btn-next {
  display: none !important;
}
/deep/.pagination .el-pager li:hover {
  color: #000 !important;
}
/deep/.pagination .el-pager .active {
  background: #3EAF6A !important;
  color: #fff !important;
}
/deep/.el-pagination.is-background .el-pager .number {
  background: #EEEEEE!important;
  color: #999999!important;
}
/deep/.el-pagination.is-background .el-pager .active {
  background: #3EAF6A !important;
  color: #fff !important;
}
/deep/.el-input--medium .el-input__inner {
  height: 40px!important;
}
.cardBox {
  display: flex;
  flex-wrap: wrap;
  height: 500px;
  overflow: hidden;
  background: #000;
}
.cardBox .cardimg2 {
  width: calc((100% - 0px) / 2);
  height: 50%;
  object-fit: contain;
}
.cardimg1 {
  width: calc((100% - 0px) / 1);
  height: 100%;
  object-fit: contain;
}
.autocard_layout2 {
    width: calc(50% - 2px);
    height: 100%;
    
    
    object-fit: contain;
    
  }
  .autocard_layout3 {
    width: calc(33.3% - 2px);
    height: 100%;
    
    
    object-fit: contain;
    
  }
  .autocard_layout4 {
    width: calc(25% - 2px);
    height: 100%;
    
    
    object-fit: contain;
    
  }
  .autocard_layout5 {
    width: calc(20% - 2px);
    height: 100%;
    
    
    object-fit: contain;
    
  }
  .autocard_layout6 {
    width: calc(16.6% - 2px);
    height: 100%;
    
    
    object-fit: contain;
    
  }
  
  .autocard_layout7 {
    width: 100%;
    height: calc(50% - 2px);
    
    
    object-fit: contain;
    
  }

  .autocard_layout8 {
    width: calc(50% - 2px);
    height: calc(50% - 2px);
    
    
    object-fit: contain;
    
  }
  .autocard_layout9 {
    width: calc(33.3% - 2px);
    height: calc(50% - 2px);
    
    
    object-fit: contain;
    
  }
  .autocard_layout10 {
    width: calc(25% - 2px);
    height: calc(50% - 2px);
    
    
    object-fit: contain;
    
  }
  .autocard_layout11 {
    width: calc(20% - 2px);
    height: calc(50% - 2px);
    
    
    object-fit: contain;
    
  }
  .autocard_layout12 {
    width: calc(16.6% - 2px);
    height: calc(50% - 2px);
    
    
    object-fit: contain;
    
  }

  .autocard_layout13 {
    width: 100%;
    height: calc(33.3% - 2px);
    
    
    object-fit: contain;
    
  }

  .autocard_layout14 {
    width: calc(50% - 2px);
    height: calc(33.3% - 2px);
    
    
    object-fit: contain;
    
  }
  .autocard_layout15 {
    width: calc(33.3% - 2px);
    height: calc(33.3% - 2px);
    
    
    object-fit: contain;
    
  }
  .autocard_layout16 {
    width: calc(25% - 2px);
    height: calc(33.3% - 2px);
    
    
    object-fit: contain;
    
  }
  .autocard_layout17 {
    width: calc(20% - 2px);
    height:calc(33.3% - 2px);
    
    
    object-fit: contain;
    
  }
  .autocard_layout18 {
    width: calc(16.6% - 2px);
    height: calc(33.3% - 2px);
    
    
    object-fit: contain;
    
  }



.autocard_layout19 {
    width: 100%;
    height:calc(25% - 2px);
    
    
    object-fit: contain;
    
  }

  .autocard_layout20 {
    width: calc(50% - 2px);
    height: calc(25% - 2px);
    
    
    object-fit: contain;
    
  }
  .autocard_layout21 {
    width: calc(33.3% - 2px);
    height:calc(25% - 2px);
    
    
    object-fit: contain;
    
  }
  .autocard_layout22 {
    width: calc(25% - 2px);
    height: calc(25% - 2px);
    
    
    object-fit: contain;
    
  }
  .autocard_layout23 {
    width: calc(20% - 2px);
    height:calc(25% - 2px);
    
    
    object-fit: contain;
    
  }
  .autocard_layout24 {
    width: calc(16.6% - 2px);
    height:calc(25% - 2px);
    
    
    object-fit: contain;
    
  }



  .autocard_layout25 {
    width: 100%;
    height:calc(20% - 2px);
    
    
    object-fit: contain;
    
  }

  .autocard_layout26 {
    width: calc(50% - 2px);
    height: calc(20% - 2px);
    
    
    object-fit: contain;
    
  }
  .autocard_layout27 {
    width: calc(33.3% - 2px);
    height:calc(20% - 2px);
    
    
    object-fit: contain;
    
  }
  .autocard_layout28 {
    width: calc(25% - 2px);
    height: calc(20% - 2px);
    
    
    object-fit: contain;
    
  }
  .autocard_layout29 {
    width: calc(20% - 2px);
    height:calc(20% - 2px);
    
    
    object-fit: contain;
    
  }
  .autocard_layout30 {
    width: calc(16.6% - 2px);
    height:calc(20% - 2px);
    
    
    object-fit: contain;
    
  }


  .autocard_layout31 {
    width: 100%;
    height:calc(16.6% - 2px);
    
    
    object-fit: contain;
    
  }

  .autocard_layout32 {
    width: calc(50% - 2px);
    height: calc(16.6% - 2px);
    
    
    object-fit: contain;
    
  }
  .autocard_layout33 {
    width: calc(33.3% - 2px);
    height:calc(16.6% - 2px);
    
    
    object-fit: contain;
    
  }
  .autocard_layout34 {
    width: calc(25% - 2px);
    height: calc(16.6% - 2px);
    
    
    object-fit: contain;
    
  }
  .autocard_layout35 {
    width: calc(20% - 2px);
    height:calc(16.6% - 2px);
    
    
    object-fit: contain;
    
  }
  .autocard_layout36 {
    width: calc(16.6% - 2px);
    height:calc(16.6% - 2px);
    
    
    object-fit: contain;
    
  }
.cardimg_left {
  position: absolute;
  left: 0px;
  top: 0px;
  color: #fff;
  font-size: 12px;
}
.cardimg_right {
  position: absolute;
  right: 0px;
  top: 0px;
  color: #fff;
  font-size: 12px;
}
.cardimg_bottom {
  position: absolute;
  right: 0px;
  bottom: 0px;
  color: #fff;
  font-size: 12px;
}
.warning-row {
  background: oldlace;
}
.login_Edit {
  cursor: pointer;
  width: 120px;
  height: 40px;
  font-size: 14px;
  font-weight: 500;
  background: #EEEEEE;
  border-radius: 4px;
  border: none;
  color: #999999;
}
.ok_Edit {
  cursor: pointer;
  width: 120px;
  height: 40px;
  background: #009B43;
  font-size: 14px;
  font-weight: 500;
  border-radius: 4px;
  border: none;
  margin-left: 30px;
  color: #fff;
}
/* /deep/.el-button--primary {
  background: pink!important;
} */
/deep/ .el-input__inner::placeholder {
        /* color: red; */
      }
/deep/ .colorchange .el-input__inner::-webkit-input-placeholder{

  color: #cccfd5;

}

/deep/ .searchchange .el-input__inner::-webkit-input-placeholder{

  color: #009b43; 

}
/deep/.el-select .el-input .el-select__caret.is-reverse {
  color: #009b43!important;
}




    .input-line {
      height: 40px;

      .input-title {
        float: left;
        line-height: 40px;
        font-size: 14px;
        text-align: right;
        width: 80px;

        .text {
          color: #666;
        }
      }

      .files {
        display: none;
      }

      .input {
        float: left;
        width: 400px;
        margin-left: 16px;
      }

      .icon-btn {
        margin-top: 5px;
        margin-left: 16px;
        float: left;
        height: 30px;
        line-height: 30px;
        padding-right: 10px;
        padding-left: 10px;
        background-color: #0099ff;
        border-radius: 5px;
        color: #fff;
        font-size: 14px;
        cursor: pointer;
        transition: all 0.35s;
      }

      .upload-btn {
        &:hover {
          opacity: 0.8;
        }
      }

      .ban-button {
        cursor: not-allowed;
        background-color: #eeeff3;
      }

      .loading-box {
        margin-top: 15px;
        float: left;
        width: 270px;
        height: 10px;
        background-color: #f6f6f6;
        border-radius: 5px;
        margin-left: 15px;

        .current-loading {
          height: 10px;
          border-radius: 5px;
          background-color: #3399cc;
          /*width: 50%;*/
        }
      }

      .percent-val {
        line-height: 40px;
        width: 60px;
        text-align: center;
        font-size: 14px;
        color: #666;
        float: left;
      }

      .cancel-btn {
        line-height: 40px;
        font-size: 14px;
        color: #999;
        text-decoration: underline;
        cursor: pointer;
        user-select: none;

        &:hover {
          color: #3399CC;
        }
      }

      .del-btn {
        line-height: 40px;
        font-size: 14px;
        color: #999;
        text-decoration: underline;
        cursor: pointer;
        user-select: none;

        &:hover {
          color: #3399CC;
        }
      }
    }
    .uploader-example {
    width: 90%;
    font-size: 12px;
  }
 
  .uploader-example .uploader-btn {
    margin-right: 4px;
  }
 
  .uploader-example .uploader-list {
    max-height: 440px;
    overflow: auto;
    overflow-x: hidden;
    overflow-y: auto;
  }
</style>




// WEBPACK FOOTER //
// src/views/record/index.vue